module.exports = __webpack_public_path__ + "static/media/icn_review_3.631a4eac.svg";